import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

/*const firebaseConfig = {
  apiKey: "AIzaSyBAVwtQJ_TOlUek5vX6eVNpWACvgIyKkZs",
  authDomain: "qoach-web.firebaseapp.com",
  projectId: "qoach-web",
  storageBucket: "qoach-web.firebasestorage.app",
  messagingSenderId: "677363678978",
  appId: "1:677363678978:web:893b4a2ae01d8214ca0c1b",
  //measurementId: "G-YPZ2R5YGNW"
};*/

const firebaseConfig = {
  apiKey: "AIzaSyD3z4lfq5pifockofAFWcBQC5vHxOnlVRw",
  authDomain: "qoach-f7246.firebaseapp.com",
  databaseURL: "https://qoach-f7246-default-rtdb.firebaseio.com",
  projectId: "qoach-f7246",
  storageBucket: "qoach-f7246.firebasestorage.app",
  messagingSenderId: "337868227214",
  appId: "1:337868227214:web:55bdbe4bf73b3808c23fdf",
  //measurementId: "G-DV4W9KHXYV"
};


const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

const messaging = getMessaging(app);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered:", registration);
      // Use the registered service worker for FCM
      getToken(messaging, {
        //vapidKey: "BOkJYQxn97qz0HYrYKc-7Ujj2iFXaBHHZqEA9CGn__avhQqNBMqKvSlZhiMtkh6STfU4GIXsCMKPoxbsUyvsbsQ",
        vapidKey: "BCpbAFBU448qEpUMZ2x6cAacFHrFKEmGPhA70ecxtAc5NRXrJ1W4S_WXbJWIUwGjzNDDZS2t0DwX8IienLWjgFA",
        serviceWorkerRegistration: registration,
      })
        .then((currentToken) => {
          if (currentToken) {
            console.log("FCM Token:", currentToken);
          } else {
            console.warn("No registration token available.");
          }
        })
        .catch((error) => {
          console.error("Error retrieving FCM token:", error);
        });
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

export const requestNotificationPermission = async () => {
  try {
    // Ensure that VAPID key is provided (replace YOUR_VAPID_KEY with your actual key from Firebase console)
    //const token = await getToken(messaging, { vapidKey: "BOkJYQxn97qz0HYrYKc-7Ujj2iFXaBHHZqEA9CGn__avhQqNBMqKvSlZhiMtkh6STfU4GIXsCMKPoxbsUyvsbsQ" });
    const token = await getToken(messaging, { vapidKey: "BCpbAFBU448qEpUMZ2x6cAacFHrFKEmGPhA70ecxtAc5NRXrJ1W4S_WXbJWIUwGjzNDDZS2t0DwX8IienLWjgFA" });
    console.log("FCM Token:", token);
    return token;
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
};

export const listenForMessages = () => {
  onMessage(messaging, (payload) => {
    console.log("Message received:", payload);
    alert(payload.notification.title);
  });
};
